export const de = {
  app: {
    product: "HAUFFE OS",
    workspace: "Customer Value Workspace",
    subline: "Guided Digital Access"
  },
  layout: {
    languageLabel: "Sprache",
    nav: {
      overview: "Übersicht",
      workspaces: "Workspaces",
      newWorkspace: "Neuer Workspace",
      users: "Nutzer",
      workspace: "Workspace",
      departments: "Abteilungen",
      evaluation: "HAUFFE OS Auswertung",
      customerValue: "Customer Value Calculation",
      myPlans: "Meine Pläne",
      dealWinEngine: "Deal Win Engine",
      contributor: "Meine Abteilung",
      entry: "Einstieg",
      pricing: "Preise",
      login: "Login",
      logout: "Logout"
    },
    noAccess: {
      eyebrow: "Keine Berechtigung",
      title: "Sie haben für diese Ansicht keine Berechtigung.",
      description: "Öffnen Sie die Ansicht, die Ihrem Zugang zugeordnet ist.",
      cta: "Zurück zu meiner Ansicht"
    },
    loginRequired: {
      eyebrow: "Login erforderlich",
      title: "Bitte anmelden",
      description: "Melden Sie sich an, um Ihren Customer Value Workspace zu öffnen.",
      cta: "Zum Login"
    }
  },
  home: {
    eyebrow: "Guided Digital Access",
    title: "HAUFFE OS Customer Value Workspace",
    description: "Ein digitaler Entscheidungsraum für Unternehmen, die Kundenwert, Kundensegmente und Neukundenpotenzial nach einer gemeinsamen Logik bewerten wollen.",
    cta: "Workspace öffnen",
    pricingCta: "Preise ansehen",
    cards: [
      {
        title: "Abteilungsperspektiven sichtbar machen",
        body: "Sales, Marketing, Delivery und Finance können getrennt arbeiten, ohne dass ihre Perspektiven vermischt werden."
      },
      {
        title: "Gemeinsame Customer-Value-Logik vorbereiten",
        body: "Abteilungen geben ihre Sicht getrennt ein. Daraus entsteht eine gemeinsame Bewertungslogik für Kunden, Leads und Opportunities."
      },
      {
        title: "Entscheidung bleibt beim Unternehmen",
        body: "Die App bewertet keine Personen. Sie nimmt nicht die Entscheidung ab, sondern die Unklarheit davor."
      }
    ]
  },
  login: {
    title: "Login",
    description: "Melden Sie sich an, um Ihren Customer Value Workspace zu öffnen.",
    panelTitle: "Zugang vorbereiten",
    formLabel: "Login Formular",
    email: "E-Mail-Adresse",
    password: "Passwort",
    passwordPlaceholder: "Ihr Passwort",
    note: "Der Zugang zum Workspace wird kontrolliert eingerichtet.",
    resetNote: "Passwort-Reset ist für diesen Workspace noch nicht automatisch aktiviert. Bitte wenden Sie sich an HAUFFE. HAUFFE Admin-Passwörter werden aktuell über das sichere Admin-Set-Script gesetzt.",
    demoActive: "Demo-Zugang aktiv.",
    submit: "Einloggen"
  },
  setupPassword: {
    title: "Passwort setzen",
    description: "Richten Sie Ihr Passwort ein, um den HAUFFE OS Customer Value Workspace zu öffnen.",
    readyTitle: "Zugang ist bereit",
    newPasswordTitle: "Neues Passwort",
    readyBody: "Ihr Passwort wurde gesetzt. Sie können sich jetzt anmelden.",
    loginCta: "Zum Login",
    missingToken: "Der Passwort-Link fehlt oder ist unvollständig.",
    mismatch: "Die Passwörter stimmen nicht überein.",
    password: "Passwort",
    confirmPassword: "Passwort bestätigen",
    note: "Der Link ist einmalig verwendbar und 24 Stunden gültig.",
    submit: "Passwort speichern"
  },
  setupAccount: {
    title: "Account erstellen",
    description: "Erstellen Sie Ihren HAUFFE OS Account nach bestätigter Zahlung.",
    panelTitle: "Account einrichten",
    readyTitle: "Workspace ist bereit",
    readyBody: "Ihr Account wurde erstellt. Der Workspace ist jetzt verfügbar.",
    openWorkspace: "Workspace öffnen",
    missingToken: "Der Account-Link fehlt oder ist unvollständig.",
    mismatch: "Die Passwörter stimmen nicht überein.",
    error: "Der Account konnte nicht erstellt werden.",
    name: "Name optional",
    password: "Passwort",
    confirmPassword: "Passwort bestätigen",
    note: "Der Link ist einmalig verwendbar. Zugriff wird erst nach bestätigter Zahlung und Account-Erstellung aktiviert.",
    submit: "Account erstellen"
  },
  pricing: {
    eyebrow: "HAUFFE OS kaufen",
    title: "Hauffe OS Preisliste",
    description: "Wählen Sie Guided Digital Access, Deal Win Engine oder eine passende Kombination. Alle Preise verstehen sich netto für B2B-Kunden.",
    guidedSectionTitle: "Guided Digital Access für Customer Value",
    dealWinSectionTitle: "Deal Win Engine",
    executiveIncluded: "Geschäftsleitung immer inklusive – zählt nicht als Abteilung.",
    includedUsers: "inklusive Zugänge",
    extraUsersAvailable: "Weitere Zugänge flexibel ergänzbar",
    dealWinSingleBadge: "Fokussierter Einstieg",
    dealWinBundleBadge: "Teamvorteil",
    dealWinSelect: "Dieses Paket wählen",
    bundleDiscountHint: "Team 3, 5 oder 10 mit Guided Digital Access kombinieren und 10 % Vorteil auf Guided sichern.",
    bundleDiscountActive: "10 % Bundle-Vorteil auf Guided Digital Access vorgesehen.",
    bundleCheckoutPrepared: "10 % Bundle-Vorteil auf Guided Digital Access vorgesehen. Der Bundle-Checkout wird vorbereitet.",
    dealWinCheckoutPrepared: "Nach dem Kauf verwaltet der Account Owner die Zugänge und weist Lizenzen intern zu.",
    guidedOnlyCheckoutNote: "Aktuell wird nur Guided Digital Access über diesen Checkout gebucht. Deal Win Engine Checkout wird separat gestartet.",
    separateCheckoutNote: "Guided Digital Access und Deal Win Engine werden aktuell über getrennte Checkouts gebucht.",
    loadError: "Preise konnten nicht geladen werden.",
    checkoutError: "Checkout konnte nicht gestartet werden.",
    successTitle: "Zahlung wird geprüft",
    successBody: "Vielen Dank. Sobald Stripe die Zahlung bestätigt hat, sendet HAUFFE OS den Account-Link per E-Mail.",
    successNote: "Die Success-Seite aktiviert keinen Zugriff. Der Workspace wird erst nach verifiziertem Webhook und Account-Erstellung freigeschaltet.",
    cancelledTitle: "Checkout abgebrochen",
    cancelledBody: "Der Kauf wurde nicht abgeschlossen. Sie können jederzeit erneut einen Plan auswählen.",
    formTitle: "Plan buchen",
    summaryTitle: "Ihre Auswahl",
    summaryEmpty: "Wählen Sie einen Plan aus, um Ihre Zusammenfassung zu sehen.",
    selectedPlan: "Gewählter Plan",
    duration: "Laufzeit",
    basePrice: "Grundpreis",
    addonPrice: "Zusatzabteilungen",
    discount15: "Rabatt 15%",
    upgradeDiscount15: "Upgrade mit 15% Rabatt",
    renewalDiscount15: "Verlängerung mit 15% Rabatt",
    totalPrice: "Gesamtpreis",
    vatNote: "zzgl. gesetzlicher Umsatzsteuer",
    discountError: "Der Rabatt konnte nicht angewendet werden. Bitte wenden Sie sich an den Support.",
    stripeNote: "Zahlung über Stripe",
    noExtraDepartments: "Keine zusätzlichen Abteilungen",
    email: "E-Mail-Adresse",
    company: "Unternehmen",
    name: "Name optional",
    extraDepartments: "Zusätzliche Abteilungen",
    extraDepartmentsProduct: "Zusätzliche Abteilungen (Guided Digital Access)",
    legalNote: "Mit dem Checkout starten Sie eine sichere Stripe-Zahlung. Der produktive Zugang entsteht erst nach Zahlungsbestätigung und Account-Setup.",
    buyNow: "Auswahl kaufen",
    dealWinBuyNow: "Deal Win Engine kaufen",
    checkoutPrepared: "Checkout wird vorbereitet",
    extraDealWinUsers: "Zusätzliche Deal-Win-Zugänge",
    extraDealWinUsersProduct: "Zusätzliche Zugänge (Deal Win Engine)",
    totalDealWinUsers: "Deal-Win-Zugänge gesamt",
    dealWinTotalPrice: "Deal Win Engine gesamt",
    existingCustomer: "Ich habe bereits Zugang",
    includedDepartments: "Abteilungen inklusive",
    extraDepartmentOnce: "netto je zusätzliche Abteilung",
    extraDepartmentMonthly: "netto monatlich je zusätzliche Abteilung",
    months: "Monate",
    monthlyNotice: "Monatlich kündbar mit Frist zum nächsten Abrechnungszeitraum",
    perMonth: "netto / Monat",
    net: "netto",
    selectPlan: "Plan auswählen",
    selected: "Ausgewählt"
  },
  workspace: {
    login: "Login",
    setupPassword: "Passwort einrichten",
    contributorWorkspace: "Contributor Workspace",
    ownerWorkspace: "Company Owner Workspace",
    evaluation: "HAUFFE OS Auswertung",
    department: "Abteilung",
    departmentPerspective: "Abteilungsperspektive",
    valueRound: "Value-Runde",
    identifyCriteria: "Customer-Value-Kriterien ermitteln",
    clusterCriteria: "Kriterien clustern",
    finalizeWeighting: "Gewichtung finalisieren",
    customerValueCalculation: "Customer Value Calculation",
    newCustomerValueCalculation: "New Customer Value Calculation",
    scoringLogic: "Bewertungslogik",
    numericRange: "Zahlenbereich",
    unit: "Einheit",
    scoringScale: "Punkteskala 1 bis 10"
  },
  contributorDepartment: {
    assignedOnlyTitle: "Perspektive ist zugeordnet",
    assignedOnlyBody: "Diese Perspektive ist dem eingeladenen Contributor zugeordnet. Bitte lassen Sie die Person ihre Perspektive selbst einreichen.",
    assignedOnlyError: "Diese Perspektive kann nur von der zugeordneten Person eingereicht werden.",
    valueRoundOpensAfterEvaluation: "Die Value-Round öffnet nach der HAUFFE OS Auswertung der ersten Perspektiven."
  },
  pdf: {
    title: "HAUFFE OS Auswertung",
    nextStep: "Nächster Schritt: Customer-Value-Kriterien ermitteln",
    footer: "HAUFFE OS Customer Value Workspace"
  },
  email: {
    valueRoundOpened: "Neue Value-Runde im HAUFFE OS Workspace",
    valueRoundCompleted: "Alle Value-Perspektiven wurden eingereicht",
    calculationReady: "Customer Value Calculation bereit zur Prüfung",
    calculationConfirmed: "Customer Value Calculation bestätigt"
  },
  dealWinEngine: {
    eyebrow: "Workspace-Modul",
    title: "Deal Win Engine",
    description: "Bewerte konkrete Opportunities, erkenne Risiken und sieh, welche Hebel die Abschlusswahrscheinlichkeit erhöhen.",
    overview: "Deals",
    newDeal: "Neuen Deal anlegen",
    empty: "Noch keine Deals angelegt. Lege deinen ersten Deal an, um die Abschlusswahrscheinlichkeit zu bewerten.",
    loading: "Deal Win Engine wird geladen...",
    loadError: "Deal-Win-Engine-Daten konnten nicht geladen werden.",
    open: "Öffnen",
    archive: "Deal archivieren",
    archiveConfirm: "Dieser Deal wird archiviert und aus der normalen Übersicht ausgeblendet. Historische Assessments bleiben erhalten.",
    edit: "Deal bearbeiten",
    save: "Deal speichern",
    cancel: "Abbrechen",
    assess: "Deal bewerten",
    reassessNote: "Bewerte den Deal erneut, um Änderungen im Score zu sehen.",
    latestAssessment: "Aktuelle Deal-Einschätzung",
    noAssessment: "Für diesen Deal liegt noch keine Bewertung vor.",
    noAssessmentGuidance: "Dieser Deal wurde noch nicht bewertet. Starte die erste Bewertung, um Abschlusswahrscheinlichkeit, Risiken und Verbesserungshebel zu sehen.",
    noAssessmentDetail: "Noch keine Bewertung vorhanden. Erfasse die Deal-Daten und starte die erste Deal-Einschätzung.",
    assessNow: "Deal jetzt bewerten",
    scoreBreakdown: "Score-Aufschlüsselung",
    winProbability: "Abschlusswahrscheinlichkeit",
    dealScore: "Deal-Qualitätsscore",
    dealValueLabel: "Deal Value",
    expectedSigning: "Erwartetes Signing",
    dealStatus: "Deal-Status",
    currentDealQuality: "Aktuelle Deal-Qualität",
    dealValueMeaning: "Wirtschaftlicher Wert der Opportunity",
    winProbabilityMeaning: "Geschätzte Abschlusswahrscheinlichkeit, keine Zusage",
    expectedSigningMeaning: "Aktueller Zieltermin für den Abschluss",
    statusMeaning: "Aktueller Prozessstatus",
    currentDealQualityMeaning: "Reifegrad und Kontrollierbarkeit nach bekannten Kriterien",
    biggestRisk: "Größtes Risiko",
    strongestLever: "Wichtigster nächster Hebel",
    lastAssessed: "Zuletzt bewertet",
    reviewSummary: "Management-Blick auf Deal-Qualität, Risiko und nächsten Schritt.",
    riskLevel: "Risikostufe",
    confidence: "Konfidenz",
    assessmentDate: "Bewertungsdatum",
    assessmentVersion: "Bewertungsversion",
    topLevers: "Top-Hebel zur Verbesserung",
    whatIf: "What-if-Simulation",
    nextBestAction: "Nächste beste Aktion",
    simulatedTarget: "Simulierter Zielwert",
    selectedLevers: "Ausgewählte Hebel",
    selectedScoreImpact: "Modellierter Score-Effekt",
    selectedProbabilityImpact: "Modellierte Veränderung der Abschlusswahrscheinlichkeit",
    noSelectedLevers: "Wähle einen oder mehrere Hebel aus, um die kombinierte Wirkung zu sehen.",
    simulationNote: "Simulation auf Basis der geschätzten Hebelwirkung. Einzeleffekte dürfen nicht als garantierte Prozentpunkte addiert werden; die tatsächliche Bewertung entsteht erst nach erneuter Deal-Bewertung.",
    scoreFormulaNote: "Der Deal-Qualitätsscore ergibt sich aus der Summe der gewichteten Beiträge aller Dimensionen.",
    scoreContribution: "Beitrag",
    scoreRating: "Wertung",
    scoreWeight: "Gewichtung",
    whatIfScoreGuaranteeNote: "100 Punkte bedeuten maximale Deal-Qualität im Modell, nicht 100 % Abschlussgarantie.",
    whatIfNonAdditiveNote: "Hebel zeigen modellierte Effekte auf Deal-Qualität und Steuerbarkeit. Sie sind keine automatische Addition auf die Abschlusswahrscheinlichkeit.",
    contactProfileQualitativeNote: "Ansprechpartner-Risikotreiber verbessern Gesprächsführung, Risiken und nächste Schritte. Sie verändern den Deal-Qualitätsscore nicht automatisch.",
    whatIfScoreCapReached: "Der Deal ist nach den bekannten Kriterien sehr gut abgesichert. Weitere strukturelle Hebel sind aktuell begrenzt; Sales sollte jetzt Momentum halten, Entscheidungsschritte absichern und Risiken aktiv beobachten.",
    whatIfBelowMaxNote: "Der Deal kann durch die ausgewählten Hebel besser steuerbar werden. 100 Punkte entstehen nur, wenn alle relevanten Kriterien belastbar erfüllt sind.",
    whatIfSingleLeverNote: "Der wichtigste strukturelle Hebel ist aktuell der sichtbar ausgewählte Hebel. Weitere Faktoren sind bereits ausreichend belegt oder lassen sich aus den vorhandenen Daten nicht sicher verbessern.",
    updateAndReassess: "Deal-Daten aktualisieren und erneut bewerten",
    noNextAction: "Für diese Bewertung wurde aktuell keine kritische nächste Aktion erkannt.",
    risks: "Risiken",
    actions: "Empfohlene nächste Schritte",
    levers: "Alle Hebel",
    noRisks: "Keine wesentlichen Risiken erkannt.",
    crmExport: "CRM-Export",
    crmExportIntro: "Diese Werte können als Custom Fields in HubSpot, Pipedrive, Salesforce oder einem anderen CRM übernommen werden.",
    crmFieldList: "Strukturierte Feldliste",
    crmJson: "Technischer JSON-Export ist für CRM-Feldanlagen verfügbar und kann kopiert werden.",
    crmNote: "CRM-Notiz",
    customerValueContextUsed: "Kundenwert in der Deal-Bewertung berücksichtigt",
    customerValueContextMissing: "Noch kein Kundenwert-Kontext verknüpft",
    customerValueContextMissingDescription: "Noch kein Kundenwert-Kontext verknüpft. Die Deal-Bewertung basiert aktuell nur auf den Opportunity-Daten.",
    importCustomerValueSnapshot: "Kundenwert in Deal-Bewertung einbeziehen",
    updateCustomerValueSnapshot: "Kundenwert-Kontext aktualisieren",
    customerValueSnapshotSuccess: "Kundenwert-Kontext wurde in die Deal-Bewertung einbezogen.",
    customerValueSnapshotError: "Kundenwert-Kontext konnte nicht in die Deal-Bewertung einbezogen werden.",
    customerValueSnapshotNote: "Ein konkretes Kundenwert-Segment wird nur übernommen, wenn für diesen Deal bereits ein Kundenwert-Score vorhanden ist.",
    customerValueContextStatus: "Kundenwert-Status",
    customerValueModelOnly: "Das Customer-Value-Modell ist verknüpft. Für diesen konkreten Deal fehlt noch ein Kundenwert-Score.",
    customerValueConcreteSegment: "Dieser Deal ist mit einem konkreten Kundenwert-Score bewertet.",
    customerValueCriteriaCount: "Aktive Kriterien",
    customerValueScore: "Customer-Value-Score",
    customerValueScoreHelp: "Optionaler Score von 0 bis 100. Nutze ihn, wenn der Kundenwert bereits aus Hauffe OS, CRM oder einer Bewertung bekannt ist.",
    customerFitScore: "Passung zum idealen Kundenprofil",
    customerValueCommercialFit: "Wirtschaftliche Deal-Qualität",
    customerValueSegment: "Customer-Value-Segment",
    customerValueFitCategory: "Passung zum idealen Kundenprofil",
    customerValueAssessedAt: "Customer-Value-Bewertungsdatum",
    contactProfileTitle: "Ansprechpartner-Profil",
    contactProfileDescription: "Das Profil ist eine Arbeitshypothese für Gesprächsführung und Deal-Steuerung. Es ersetzt keine persönliche Bewertung.",
    contactProfileSummary: "Ansprechpartner-Profil für die Gesprächsführung hinterlegt",
    contactProfileMissing: "Noch kein Ansprechpartner-Profil hinterlegt.",
    contactProfileSave: "Ansprechpartner-Profil speichern",
    contactProfileHypothesis: "Arbeitshypothese für die Gesprächsführung",
    contactProfileHelp: "Nutze das Profil, wenn Entscheidungsstil, Nachweisbedarf oder Risikotreiber im Gespräch erkennbar sind.",
    contactProfileReviewHint: "Hinweis aus Ansprechpartner-Profil",
    proofStatusTitle: "Nachweis-Reife",
    proofStatusDescription: "Bewerte nur die Nachweise, die für diesen Ansprechpartner relevant sind. Fehlende Nachweise können Risiken und nächste Schritte beeinflussen.",
    nextStepQualityTitle: "Qualität des nächsten Schritts",
    contactProfileSectionInstructions: {
      riskTriggers: "Wähle die Risikotreiber, die diesen Ansprechpartner im Entscheidungsprozess bremsen könnten.",
      proofPreference: "Wähle die Nachweise, die für diesen Ansprechpartner eine Entscheidung belastbarer machen.",
      recommendedApproach: "Wähle den Gesprächsansatz, mit dem Sales den nächsten Schritt führen sollte."
    },
    contactProfileSelected: "Ausgewählt",
    contactProfileLabels: {
      source: "Quelle",
      confidence: "Sicherheit der Einschätzung",
      decisionStyle: "Entscheidungsstil",
      communicationPreference: "Kommunikationspräferenz",
      riskTriggers: "Risikotreiber",
      proofPreference: "Bevorzugte Nachweise",
      recommendedApproach: "Empfohlener Gesprächsansatz",
      notes: "Notiz zur Gesprächsführung"
    },
    contactProfileSources: {
      manual: "Manuell erfasst",
      crm: "Aus CRM-Feldern übernommen",
      inferred: "Aus vorhandenen Deal-Informationen abgeleitet"
    },
    contactProfileDecisionStyles: {
      analytical: "Zahlen- und faktenorientiert",
      relationship_driven: "Beziehungs- und vertrauensorientiert",
      authority_driven: "Entscheidungs- und hierarchieorientiert",
      innovation_driven: "Innovations- und zukunftsorientiert",
      risk_averse: "Sicherheits- und risikoorientiert",
      speed_oriented: "Tempo- und umsetzungsorientiert",
      consensus_driven: "Konsens- und stakeholderorientiert"
    },
    contactProfileCommunicationPreferences: {
      numbers_and_facts: "Zahlen, Fakten und Entscheidungsgrundlage",
      strategic_vision: "Strategisches Zielbild",
      operational_detail: "Operative Details und Umsetzung",
      trust_and_relationship: "Vertrauen und Beziehung",
      proof_and_references: "Nachweise und Referenzen",
      concise_executive_summary: "Kurze Executive Summary"
    },
    contactProfileRiskTriggers: {
      unclear_roi: "Unklarer ROI",
      implementation_effort: "Umsetzungsaufwand",
      internal_politics: "Interne Politik",
      budget_uncertainty: "Budgetunsicherheit",
      loss_of_control: "Kontrollverlust",
      reputational_risk: "Reputationsrisiko",
      missing_references: "Fehlende Referenzen",
      unclear_decision_path: "Unklarer Entscheidungspfad"
    },
    contactProfileRiskTriggerDescriptions: {
      unclear_roi: "Der wirtschaftliche Nutzen ist noch nicht belastbar genug, um intern sicher zu entscheiden.",
      implementation_effort: "Der Ansprechpartner könnte Aufwand, Ressourcen oder interne Belastung höher bewerten als den Nutzen.",
      internal_politics: "Mehrere Interessen oder verdeckte Blocker können den Abschluss verlangsamen.",
      budget_uncertainty: "Budgetlogik oder Zahlungsbereitschaft sind noch nicht entscheidungsfähig geklärt.",
      loss_of_control: "Der Ansprechpartner könnte befürchten, Kontrolle über Prozess, Daten oder Entscheidung zu verlieren.",
      reputational_risk: "Die Entscheidung könnte intern sichtbar sein und persönliche oder fachliche Risiken tragen.",
      missing_references: "Es fehlen belastbare Belege aus vergleichbaren Situationen.",
      unclear_decision_path: "Es ist noch nicht klar, wer final entscheidet und welche Schritte bis dahin notwendig sind."
    },
    contactProfileProofPreferences: {
      business_case: "Business Case",
      customer_reference: "Kundenreferenz",
      roi_calculation: "ROI-Rechnung",
      implementation_plan: "Umsetzungsplan",
      executive_summary: "Executive Summary",
      technical_validation: "Fachliche oder technische Validierung",
      pilot_or_test: "Pilot oder Test"
    },
    contactProfileProofPreferenceDescriptions: {
      business_case: "Zahlenbasierte Entscheidungsgrundlage mit Nutzen, Aufwand und wirtschaftlichem Effekt.",
      customer_reference: "Beleg durch vergleichbaren Kunden oder ähnliche Ausgangslage.",
      roi_calculation: "Konkrete Wirtschaftlichkeitslogik statt allgemeiner Nutzenargumentation.",
      implementation_plan: "Sicherheit durch klare Schritte, Verantwortlichkeiten und Aufwandstransparenz.",
      executive_summary: "Verdichtete Entscheidungsunterlage für Management und Buying Center.",
      technical_validation: "Fachliche oder technische Absicherung der Machbarkeit.",
      pilot_or_test: "Risikoarme Bestätigung, bevor eine größere Entscheidung getroffen wird."
    },
    proofStatusLabels: {
      missing: "Fehlt",
      partial: "Teilweise vorhanden",
      provided: "Vorhanden",
      strong: "Belastbar",
      similar: "Ähnliche Referenz",
      matching: "Passende Referenz",
      planned: "Geplant",
      running: "Läuft",
      completed: "Abgeschlossen"
    },
    proofStatusHelp: {
      business_case: "Dieser Ansprechpartner braucht eine wirtschaftliche Entscheidungsgrundlage.",
      customer_reference: "Dieser Ansprechpartner braucht glaubwürdigen Nachweis aus vergleichbarer Situation.",
      roi_calculation: "Dieser Ansprechpartner braucht eine nachvollziehbare ROI-Logik.",
      implementation_plan: "Dieser Ansprechpartner braucht Klarheit zur Umsetzung.",
      executive_summary: "Dieser Ansprechpartner braucht eine entscheidungsfähige Management-Zusammenfassung.",
      technical_validation: "Dieser Ansprechpartner braucht belastbare technische Validierung.",
      pilot_or_test: "Dieser Ansprechpartner braucht eine risikoarme Validierung vor der größeren Entscheidung."
    },
    nextStepQualityLabels: {
      none: "Kein nächster Schritt",
      vague: "Vage Rückmeldung",
      follow_up: "Follow-up ohne Entscheidungsziel",
      scheduled: "Konkreter Termin",
      decision_meeting: "Entscheidungstermin",
      executive_decision: "Executive-Entscheidungsschritt"
    },
    contactProfileRecommendedApproaches: {
      lead_with_business_case: "Mit Business Case führen",
      reduce_perceived_risk: "Wahrgenommenes Risiko reduzieren",
      secure_internal_sponsor: "Internen Sponsor sichern",
      show_reference_or_proof: "Referenz oder Nachweis zeigen",
      clarify_decision_path: "Entscheidungspfad klären",
      create_executive_summary: "Executive Summary erstellen",
      align_on_next_decision: "Nächsten Beschluss gemeinsam festlegen"
    },
    contactProfileRecommendedApproachDescriptions: {
      lead_with_business_case: "Den nächsten Schritt über wirtschaftlichen Nutzen, Entscheidungslogik und Priorität steuern.",
      reduce_perceived_risk: "Einwände vorwegnehmen und Sicherheit über Referenz, Plan oder Pilot schaffen.",
      secure_internal_sponsor: "Eine Person im Buying Center aktivieren, die den Bedarf intern trägt.",
      show_reference_or_proof: "Mit einem belastbaren Nachweis Vertrauen in Entscheidung und Umsetzung schaffen.",
      clarify_decision_path: "Festlegen, wer entscheidet, wer beeinflusst und welcher Beschluss als Nächstes nötig ist.",
      create_executive_summary: "Eine knappe Entscheidungsunterlage für Geschäftsführung oder Buying Center vorbereiten.",
      align_on_next_decision: "Den nächsten konkreten Beschluss gemeinsam mit dem Kunden festziehen."
    },
    decisionMakerAccessOptions: {
      yes: "Ja",
      no: "Nein",
      unknown: "Unklar"
    },
    formSections: {
      dealContext: "Deal-Kontext",
      decisionQuality: "Entscheidungsqualität",
      customerValueFit: "Kundenwert & Passung"
    },
    copyJson: "JSON kopieren",
    copyNote: "CRM-Notiz kopieren",
    copied: "Kopiert",
    copyUnavailable: "Kopieren ist in diesem Browser nicht verfügbar. Der Text bleibt sichtbar und kann manuell kopiert werden.",
    noCrmSync: "Kein automatischer CRM-Abgleich. Diese Daten werden nur zum manuellen Kopieren angezeigt.",
    history: "Letzte Bewertungen",
    back: "Zurück zur Deal Win Engine",
    details: "Deal-Stammdaten",
    formTitle: "Deal-Daten",
    createSuccess: "Deal wurde angelegt.",
    updateSuccess: "Deal wurde aktualisiert.",
    archiveSuccess: "Deal wurde archiviert.",
    assessSuccess: "Deal wurde bewertet.",
    fields: {
      title: "Deal-Titel",
      companyName: "Unternehmen",
      dealValue: "Deal-Wert",
      currency: "Währung",
      salesStage: "Vertriebsphase",
      expectedCloseDate: "Erwartetes Abschlussdatum",
      ownerName: "Verantwortlich",
      status: "Status",
      contactName: "Kontaktname",
      contactEmail: "Kontakt-E-Mail",
      industry: "Branche",
      companySize: "Unternehmensgröße",
      decisionMakerAccess: "Entscheiderzugang",
      buyingCenterKnown: "Buying Center bekannt",
      budgetConfirmed: "Budget bestätigt",
      painConfirmed: "Kundenproblem bestätigt",
      urgencyLevel: "Dringlichkeit",
      competitorKnown: "Wettbewerb bekannt",
      offerSentAt: "Angebot gesendet am",
      lastActivityAt: "Letzte Aktivität",
      customerValueScore: "Kundenwert-Score für diesen Deal",
      nextStep: "Nächster Schritt",
      notes: "Notizen"
    },
    yes: "Ja",
    no: "Nein",
    unknown: "Unklar"
  }
} as const;
